module.exports = __webpack_public_path__ + "img/cnh-verso.5de205bc.jpg";